var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGhost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.94444C4 5.55142 7.58718 2 12 2C16.4129 2 20 5.55142 20 9.94444V20.2023C20 21.5744 18.4929 22.4129 17.3271 21.6892L17.3271 21.6892L16.1636 20.967L16.1635 20.967C15.8 20.7413 15.3464 20.7173 14.961 20.9034L14.9609 20.9034L13.1956 21.7556C12.4403 22.1203 11.5597 22.1203 10.8044 21.7556L9.03906 20.9034L9.03899 20.9034C8.65365 20.7173 8.19997 20.7413 7.83644 20.967L7.83641 20.967L6.6729 21.6892C5.50706 22.4129 4 21.5744 4 20.2023V9.94444ZM12 3.5C8.4047 3.5 5.5 6.3907 5.5 9.94444V20.2023C5.5 20.3984 5.71536 20.5181 5.88182 20.4148L5.88183 20.4148L7.04532 19.6926C7.84519 19.1961 8.84343 19.1433 9.69121 19.5526L11.4565 20.4048L11.4566 20.4048C11.7999 20.5705 12.2001 20.5705 12.5434 20.4048L12.5435 20.4048L14.3088 19.5526C14.3088 19.5526 14.3088 19.5526 14.3089 19.5526C15.1566 19.1433 16.1548 19.1961 16.9546 19.6926M16.9547 19.6926L18.1181 20.4148C18.1181 20.4148 18.1181 20.4148 18.1181 20.4148C18.2847 20.5181 18.5 20.3984 18.5 20.2023V9.94444C18.5 6.3907 15.5953 3.5 12 3.5",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.5C8 9.67159 8.67157 9 9.5 9C10.3284 9 11 9.67159 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10.5C13 9.67159 13.6716 9 14.5 9C15.3284 9 16 9.67159 16 10.5C16 11.3284 15.3284 12 14.5 12C13.6716 12 13 11.3284 13 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.c2b660267bea954c0302b87dd4d22d89.svg";
export { ForwardRef as ReactComponent };